import React from 'react';
import { FaDownload } from 'react-icons/fa';
import portfolioData from '../data/portfolioData';

const AboutSection: React.FC = () => (
  <section id="about" className="section about">
    <div className="container">
      <h2 className="section__title">À propos</h2>
      <div className="section__divider" />

      {/* 3 Pillars */}
      <div className="about__pillars">
        {portfolioData.pillars.map((pillar, index) => (
          <div key={index} className="about__pillar">
            <pillar.icon size={28} className="about__pillar-icon" />
            <h3 className="about__pillar-title">{pillar.title}</h3>
            <p className="about__pillar-desc">{pillar.description}</p>
          </div>
        ))}
      </div>

      {/* Narrative & Values Block */}
      <div className="about__narrative">
        <h3 className="about__narrative-title">
          {portfolioData.aboutNarrative.title}
        </h3>
        <p className="about__narrative-text">
          {portfolioData.aboutNarrative.paragraph}
        </p>

        {/* Core Values Grid */}
        <div className="about__values">
          {portfolioData.aboutNarrative.values.map((val, index) => (
            <div key={index} className="about__value-card">
              <div className="about__value-header">
                <val.icon className="about__value-icon" size={20} />
                <h4 className="about__value-title">{val.title}</h4>
              </div>
              <p className="about__value-desc">{val.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* CV Download */}
      <div className="about__cv">
        <a
          href={require('../assets/CV_Dimitri_Bonsou_Stage.pdf')}
          download="CV_Dimitri_Bonsou.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn--secondary"
        >
          <FaDownload size={14} />
          Télécharger mon CV
        </a>
      </div>
    </div>
  </section>
);

export default AboutSection;
